import { ThemeConfig } from 'antd-v5';
import { theme } from 'styles/theme';
import { DEFAULT_FONT_FAMILY } from 'UI';

const clear_blue = 'rgb(24, 144, 255)';
const spinGrey = 'rgba(0, 0, 0, 0.75)';
export const antLessTheme: ThemeConfig = {
  token: {
    colorPrimary: clear_blue,
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  components: {
    Spin: {
      colorPrimary: spinGrey,
    },
    Slider: {
      colorPrimary: clear_blue,
    },
    Radio: {
      colorPrimary: clear_blue,
      fontFamily: DEFAULT_FONT_FAMILY,
      colorText: theme.color.brand_black,
    },
    Table: {
      borderColor: theme.color.grey85,
      headerBg: theme.color.grey95_light,
      fontFamily: DEFAULT_FONT_FAMILY,
      colorText: theme.color.brand_black,
    },
    Upload: {
      colorLink: theme.color.clear_blue,
    },
    TreeSelect: {
      fontFamily: DEFAULT_FONT_FAMILY,
      colorText: theme.color.brand_black,
    },
    Select: {
      colorPrimary: clear_blue,
      fontFamily: DEFAULT_FONT_FAMILY,
      colorText: theme.color.brand_black,
      borderRadius: 3,
    },
    Timeline: {
      colorPrimary: theme.color.brand_black,
    },
    Divider: {
      colorSplit: theme.color.grey60,
    },
    Layout: {
      headerPadding: '0px',
      footerPadding: '0px',
      bodyBg: '#ffffff',
      headerHeight: 64,
      lineHeight: 64,
    },
    Menu: {
      itemColor: theme.color.brand_black,
      itemHoverColor: theme.color.brand_black,
      itemSelectedColor: theme.color.brand_black,
      itemHoverBg: theme.color.grey95,
      itemSelectedBg: theme.color.grey90,
      itemActiveBg: theme.color.grey90,
      fontFamily: DEFAULT_FONT_FAMILY,
    },
  },
};
